import { Pipe, PipeTransform } from '@angular/core';
import { Lookup } from 'src/app/shared/models/lookup.model';

@Pipe({
    name: 'onlyOneSelected',
    pure: true,
    standalone: true
})
export class OnlyOneSelectedPipe implements PipeTransform {
    transform<T extends Lookup>(array: T[], selected: number[], current: number | null | undefined): T[] {
        if (!Array.isArray(array)) {
            return array;
        }
        if (!Array.isArray(selected)) {
            return array;
        }

        return array.filter((item) => item.id === current || !selected.includes(item.id));
    }
}
